<script>
import ActualitiesService from '@/services/actualities'
import EventsService from '@/services/events'
import StoresServices from '@/services/stores'
import ReportService from '@/services/reports'
import CitiesService from '@/services/cities'
import UsefulInfosServices from '@/services/usefulInfo'
import LostObjectsServices from '@/services/lostObjects'
import LostPetsServices from '@/services/lostPets'
import EnvironmentUtils from '@/utils/environmentUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import VueUtils from '@/utils/vueUtils'
import AuthUtils from '@/utils/authUtils'
import EventsUtils from '@/utils/eventsUtils'
import ReleaseNotesDialog from '@/components/ReleaseNotesDialog'
import { waitUntilUserIsFetched } from '@/stores/index'
import Package from '~/package.json'
import StoreLoyaltyCardFrame from '@/frames/storeLoyaltyCardFrame'

export default
{
    name: 'edit',

    created ()
    {
        this.fetchEditionData()

        const token = AuthUtils.decodeJWT(LocalStorageUtils.token)
        if (!token || token.expirationDate < Date.now() || (!this.$store.state.user.isLogged && EnvironmentUtils.isProductionEnv))
        {
            console.warn('User token', token, 'invalid, redirecting to login form')
            const currentPath = this.$route.fullPath
            this.$router.push({ name: 'Login', params: {onSuccessful: () => this.$router.replace(currentPath)}, replace: true })

            return
        }

        if (LocalStorageUtils.lastAdminReleaseNotesSeen != Package.version)
        {
            EventsUtils.onSplashscreenHidden().then(() =>
            {
                LocalStorageUtils.lastAdminReleaseNotesSeen = Package.version

                console.log('User did not read admin release notes for', Package.version, 'showing it')
                const releaseNotes = require('~/static/release_notes.json').find(r => r.version == Package.version)
                if (!releaseNotes) console.warn('No release notes found for', Package.version)
                else VueUtils.createComponent(ReleaseNotesDialog, { release: releaseNotes, showAdminReleaseNotes: true })
            })
        }
    },

    render () 
    {   
        return (
            <div id='edit'>
                <router-view />
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    mounted ()
    {
    },

    methods:
    {
        async fetchEditionData ()
        {
            await waitUntilUserIsFetched()

            const cityId = EnvironmentUtils.cityId
            const user = this.$store.state.user
            const token = await user.token
            const privileges = user.privileges
            const features = EnvironmentUtils.cityFeatures

            if (privileges.canEditActualities)
            {
                ActualitiesService.fetchActualities(cityId, token, {from: 0, number: 1000, includeDrafts: true, includeScheduled: true, excludeContent: true}).then(actualities =>
                {
                    this.$store.commit('actualities/updateActualityList', actualities)
                })
            }

            if (privileges.canEditEvents)
            {
                EventsService.fetchEvents(cityId, token, {includeUnpublished: true}).then(events  =>
                {
                    this.$store.commit('events/updateEventList', events)
                })
            }

            if (privileges.canEditStores)
            {
                StoresServices.fetchStores(cityId).then(stores  =>
                {
                    this.$store.commit('stores/updateStoreList', stores)
                })
            }

            if (privileges.canEditUsefulInfos)
            {
                UsefulInfosServices.fetchInfos(EnvironmentUtils.cityId).then(infos  =>
                {
                    this.$store.commit('usefulInfos/updateInfoList', infos)
                })
            }

            if (privileges.canManageReports)
            {
                ReportService.fetchReports(cityId, token, 'pending').then(reports =>
                {
                    this.$store.commit('reports/updateReportsList', reports)
                })
            }

            if (privileges.canManageLostObjects)
            {
                LostObjectsServices.getLostObjectsTagsDefinition(cityId, token).then(async tags =>
                {
                    this.$store.commit('lostObjects/setTags', tags)

                    const objects = await LostObjectsServices.fetchLostObjects(cityId, token)
                    this.$store.commit('lostObjects/updateObjectsList', objects)
                })
            }

            if (privileges.canManageLostPets)
            {
                LostPetsServices.getLostPetsTagsDefinition(cityId, token).then(async tags =>
                {
                    this.$store.commit('lostPets/setTags', tags)

                    const pets = await LostPetsServices.fetchLostPets(cityId, token)
                    this.$store.commit('lostPets/updatePetsList', pets)
                })
            }

            if (privileges.canManageAccounts)
            {
                CitiesService.getCityAdministrators(cityId, token).then(cityAdministrators =>
                {
                    for (const accountId of cityAdministrators)
                    {
                        this.$store.dispatch('cities/fetchAdministratorAccount', { cityId, token, accountId })
                    }
                })
            }

            if (user.ownedStore)
            {
                this.$store.dispatch('stores/fetchStoreNotificationQuota', { cityId, storeId: user.ownedStore.id, token })
                if (features.hasLoyaltyCard)
                {
                    StoreLoyaltyCardFrame.initFrame(this.$store, user.ownedStore.id, true)
                }
            }
        }
    },

    components:
    {
    }
}
</script>

<style lang='less' scoped>
@import '~@/styles/main.less';

#edit
{
}
</style>



// WEBPACK FOOTER //
// src/views/Edit.vue